import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

const STATUS_OPTIONS = ["ACTIVE", "DEACTIVATED"];
const SORT_OPTIONS = [
  { value: "newest", label: "Newest" },
  { value: "oldest", label: "Oldest" },
];

const StaffFilters = ({ onSearchSubmit, statusFilter, onStatusChange, sort, onSortChange }) => {
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-4 shadow-sm">
      <div className="flex flex-col gap-3 md:flex-row md:items-center">
        <div className="flex min-h-11 w-full max-w-xl items-center gap-3 rounded-lg border border-slate-200 bg-slate-50 px-3 text-slate-500 focus-within:border-slate-400 focus-within:bg-white">
          <FontAwesomeIcon
            icon={faSearch}
            onClick={() => {
              const searchInput = document.querySelector(".staffSearchBar");
              if (searchInput) {
                onSearchSubmit(searchInput.value);
              }
            }}
            style={{ cursor: "pointer" }}
          />
          <input
            type="text"
            className="staffSearchBar w-full bg-transparent text-sm text-slate-700 outline-none placeholder:text-slate-400"
            placeholder="Search staff by name or email"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                onSearchSubmit(e.target.value);
              }
            }}
          />
        </div>

        <div className="flex items-center gap-2">
          <select
            className="form-select"
            style={{ minWidth: "140px" }}
            value={statusFilter}
            onChange={(e) => onStatusChange(e.target.value)}
          >
            <option value="">All Statuses</option>
            {STATUS_OPTIONS.map((status) => (
              <option key={status} value={status}>
                {status}
              </option>
            ))}
          </select>

          <select
            className="form-select"
            style={{ minWidth: "150px" }}
            value={sort}
            onChange={(e) => onSortChange(e.target.value)}
          >
            {SORT_OPTIONS.map((opt) => (
              <option key={opt.value} value={opt.value}>
                Sort: {opt.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default StaffFilters;